import { render, staticRenderFns } from "./ForwardRequestModal.vue?vue&type=template&id=df9b51a0&scoped=true&"
import script from "./ForwardRequestModal.vue?vue&type=script&lang=js&"
export * from "./ForwardRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./ForwardRequestModal.vue?vue&type=style&index=0&id=df9b51a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9b51a0",
  null
  
)

export default component.exports